import Swiper from "swiper/bundle";

const CapabilityIconsSlider = () => {
  const capabilityIconsSliders = [...document.querySelectorAll(".capability-icons__slider")];

  const initializeSlider = () => {
    capabilityIconsSliders.forEach((capabilityIconsSlider) => {
      const pagination = capabilityIconsSlider.querySelector(".slider__pagination");
      const btns = document.querySelector(".capability-icons .slider__btns");
      const nextBtn = document.querySelector(".capability-icons__slider-btn-next");
      const prevBtn = document.querySelector(".capability-icons__slider-btn-prev");

      const slides = [...capabilityIconsSlider.querySelectorAll('.swiper-slide')];


      const minSlidesForMobile = 2;
      const minSlidesForTablet = 3;
      const minSlidesForDesktop = 4;

      const shouldInitializeSlider =  (window.innerWidth >= 1440 && slides.length > minSlidesForDesktop) ||
                                      (window.innerWidth < 1440 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
                                      (window.innerWidth < 768 && slides.length > minSlidesForMobile);
      
      if (!shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.add("d-none");
          pagination.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (btns && pagination) {
          btns.classList.remove("d-none");
          pagination.classList.remove("d-none");
        }

        const capabilityIconsCarousel = new Swiper(capabilityIconsSlider, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          // loop: true,
          pagination: {
            el: pagination,
            clickable: true,
          },
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            768: {
              slidesPerView: 'auto',
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 24,
            },
            1441: {
              slidesPerView: 'auto',
              spaceBetween: 32,
            },
          },
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    capabilityIconsSliders.forEach((capabilityIconsSlider) => {
      const swiperInstance = capabilityIconsSlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
};

export default CapabilityIconsSlider;

